import { render, staticRenderFns } from "./camodevicedetail.vue?vue&type=template&id=665dffe8&scoped=true&"
import script from "./camodevicedetail.vue?vue&type=script&lang=js&"
export * from "./camodevicedetail.vue?vue&type=script&lang=js&"
import style0 from "./camodevicedetail.vue?vue&type=style&index=0&id=665dffe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665dffe8",
  null
  
)

export default component.exports